import { ref, type Ref } from "vue";
import type { ComponentExposed } from "vue-component-type-helpers";
import { R3VisualComponentBase } from "./R3VisualComponenteBase.classes";
import type Calendar from "primevue/calendar";

interface _CalendarWithOverlay extends ComponentExposed<typeof Calendar> {
	overlayVisible?: boolean;
	$el?: HTMLElement;
	focus?: () => void;
}

export class R3CalendarClass extends R3VisualComponentBase {
	private _inputValue: Ref<Date | null> = ref(null);
	public get inputValue(): Date | null {
		return this._inputValue.value;
	}

	public set inputValue(newDate: Date | null) {
		this._inputValue.value = newDate;
	}

	dateFormat: string = "dd/mm/yy";


	// Sobrescrever setFocus para usar o calendar específico
	override async setFocus(): Promise<void> {
		if (this.elemento?.value == null) {
			throw new Error("Calendar element not defined");
		} else {
			// Para Calendar do PrimeVue, vamos focar no input interno
			const calendarInstance = this.elemento.value as unknown as _CalendarWithOverlay;
			if (calendarInstance.$el) {
				const inputElement = calendarInstance.$el.querySelector('input');
				if (inputElement) {
					inputElement.focus();
				} else {
					// Fallback: usar o método focus se existir
					if (typeof calendarInstance.focus === 'function') {
						calendarInstance.focus();
					}
				}
			}
		}
	}

	show(): void {
		if (this.elemento?.value) {
			// Para PrimeVue 3, usamos a propriedade overlayVisible para controlar a visibilidade
			// conforme encontrado no StackOverflow: ca.value.overlayVisible = true
			(this.elemento.value as unknown as _CalendarWithOverlay).overlayVisible = true;
		}
	}

	hide(): void {
		if (this.elemento?.value) {
			// Para fechar o calendário, definimos overlayVisible como false
			(this.elemento.value as unknown as _CalendarWithOverlay).overlayVisible = false;
		}
	}

	onDateSelectValidade(callback: () => void) {
		callback();
	}
	onValidadeCalendarExit(callback: () => void) {
		callback();
	}
}